import { MatDialogRef } from "@angular/material/dialog";
import { ModalExit } from "./enums";

export class ModalWindow {
  dialogRef: MatDialogRef<any>;
  ModalExit = ModalExit;

  closeModal(code: ModalExit) {
    this.dialogRef.close(code);
  }

  closeModalAndReturnOutput(output: object | string | number) {
    this.dialogRef.close(output);
  }
}
